export async function listCompanyDomains(apiClient) {
  const res = await apiClient.get('/company-domains');
  return res.data;
}

export async function getCompanyDomain(apiClient, id) {
  const res = await apiClient.get(`/company-domains/${id}`);
  return res.data;
}

export async function createCompanyDomain(apiClient, payload) {
  const res = await apiClient.post('/company-domains', payload);
  return res.data;
}

export async function updateCompanyDomain(apiClient, id, payload) {
  const res = await apiClient.put(`/company-domains/${id}`, payload);
  return res.data;
}

export async function retireCompanyDomain(apiClient, id) {
  const res = await apiClient.post(`/company-domains/${id}/retire`);
  return res.data;
}

export async function lookupCompanyByEmail(apiClient, email) {
  const res = await apiClient.get('/company-domains/lookup', {
    params: { email },
  });
  return res.data;
}
